import zipValidation from './helpers/zipValidation'

export default zipValidation